<template>
  <div class="client-devices">
    <el-card>
      <div
          slot="header"
          class="clearfix">
        <span class="header-item">{{ $t('customer_authorizations.title') }}</span>
        <span class="ring-card__header-buttons">
          <RefreshButton @click.native="fetch()" />
        </span>
      </div>
      <div class="card-content">
        <el-table
            v-loading="ajax.working"
            class="client-device-table"
            :data="authorizations">
          <el-table-column
              v-for="column in metaTable"
              v-if="showColumn({id: column.id})"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label">
            <template
                slot-scope="scope"
                style="padding-right: 3px">
              <section
                  v-if="column.prop === 'status'">
                {{ getStatusValue(scope.row) }}

                <a
                    v-if="scope.row.auth_type === 'tiv'"
                    v-loading="get(scope.row, 'refreshingStatus', false)"
                    @click="updateStatus({id: get(scope.row, 'id', '')})"> ({{ $t('common.refresh') }}) </a>
              </section>
              <section
                  v-else>
                <span v-if="column.date">
                  <time-zone-formatter :current-time="get(scope.row, column.prop, '')" />
                </span>
                <span v-else>
                  {{ get(scope.row, column.prop, '') }}
                </span>
              </section>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { get, startCase, merge } from "lodash";
import axios from "axios";
import RefreshButton from "@/containers/Customer/RefreshButton";
import { createNamespacedHelpers } from "vuex";
const { mapMutations: sharedMutations } = createNamespacedHelpers("shared");

export default {
  name: "CustomerAuthorizations",
  components: {
    RefreshButton,
  },
  props: {
    customer: { type: Object, default: () => {} },
    columns: {
      type: Array,
      default: () => {
        return [
          "auth_type",
          "created_at",
          "requested_by",
          "user_email",
          "authorized_at",
          "expires_at",
          "status",
        ];
      },
      // TODO: validate that array contain only valid columns
    },
  },
  data() {
    return {
      authorizations: [],
      ajax: {
        working: false,
      },
      metaTable: [
        {
          id: "auth_type",
          prop: "auth_type",
          label: this.$t("customer_authorizations.auth_type"),
        },
        {
          id: "created_at",
          prop: "created_at",
          date: true,
          label: this.$t("customer_authorizations.created_at"),
        },
        {
          id: "requested_by",
          prop: "requested_by",
          label: this.$t("customer_authorizations.requested_by"),
        },
        {
          id: "authorized_at",
          prop: "authorized_at",
          date: true,
          label: "Authorized at",
        },
        {
          id: "expires_at",
          prop: "expires_at",
          date: true,
          label: "Expires at",
        },
        {
          id: "status",
          prop: "status",
          label: this.$t("customer_authorizations.status"),
        },
      ],
    };
  },
  computed: {
    customerId() {
      return this.$store.getters["db/account/customerId"];
    },
  },
  watch: {
    customerId(value) {
      if (value) this.fetch();
    },
  },
  created() {
    this.fetch();
  },
  methods: {
    ...sharedMutations(["setCurrentAuthorization"]),
    get,
    startCase,
    fetch() {
      this.ajax.working = true;
      const page = "1";
      const pageSize = "30";
      const params = {
        customer_id: this.customerId,
        page: page,
        page_size: pageSize,
      };
      axios
        .get("v2/customer_authorizations", { params })
        .then((response) => {
          let authorizations = get(response, "data.authorizations", []);
          authorizations = authorizations.map((auth) => {
            auth.refreshingStatus = false;
            return auth;
          });
          this.setCurrentAuthorization(authorizations[0]);
          this.authorizations = authorizations;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.ajax.working = false));
    },
    showColumn({ id }) {
      return this.columns.includes(id);
    },
    updateStatus({ id }) {
      const auth = this.authorizations.filter((auth) => auth.id === id)[0];
      auth.refreshingStatus = true;

      axios
        .get(`v2/customer_authorizations/${id}/status`)
        .then((response) => {
          auth.status = get(response, "data.authorizationStatus", "");
        })
        .catch((error) => console.error(error))
        .finally(() => {
          auth.refreshingStatus = false;
          this.ajax.working = false;
        });
    },
    getStatusValue(row) {
      let status = get(row, "status", "");
      const invalidated = "invalidated";
      const expired = "expired";

      if (invalidated === status) {
        return expired;
      }

      return status;
    },
  },
};
</script>

<style lang="scss">
.success {
  color: green;
}
.error {
  color: red;
}
.client-device-table {
  .push-token__expanded {
    display: inline-block;
    padding: 0 17px 0 0;
    user-select: all;
    word-break: break-all;
  }
  .push-token__collapsed {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }
}
</style>
